import { render, staticRenderFns } from "./Portfolio_historic.vue?vue&type=template&id=057a6363&scoped=true&"
import script from "./Portfolio_historic.vue?vue&type=script&lang=js&"
export * from "./Portfolio_historic.vue?vue&type=script&lang=js&"
import style0 from "./Portfolio_historic.vue?vue&type=style&index=0&id=057a6363&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057a6363",
  null
  
)

export default component.exports